import GearChangesTabs from './GearChangesTabs.vue';
import state from './state/GearChangesTabs';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default { GearChangesTabs, state };
